import { z } from "zod";

export default {
  params: z.object({}),
  response: z.object({
    scaProof: z.string(),
  }),
};
